import debouncedSaveTemplate from "fantastic/lib/debouncedSaveTemplate";

export default (id, data) => (dispatch, getState) => {
  dispatch({ type: "SECTIONS/UPDATE", payload: { id, data } });
  debouncedSaveTemplate(dispatch, getState);
};
